export default "__VITE_ASSET__BXO5n89r__"